import { FC, type JSX } from 'react';

import { Sidebar, SidebarProps } from '@payaca/ambrosia';
import TaskReadCompleteView from '../taskReadCompleteView/TaskReadCompleteView';

type Props = {
  taskId?: number;
  hideDealLink?: boolean;
  onDeleteTaskSuccess?: () => void;
  onUpdateTaskSuccess?: () => void;
  isOpen: boolean;
  onClose?: () => void;
  zIndexLevel?: SidebarProps['zIndexLevel'];
};

const TaskReadCompleteDrawer: FC<Props> = ({
  taskId,
  hideDealLink,
  onDeleteTaskSuccess,
  onUpdateTaskSuccess,
  isOpen,
  onClose,
  zIndexLevel,
}: Props): JSX.Element | null => {
  return (
    <Sidebar isOpen={isOpen} onClose={onClose} zIndexLevel={zIndexLevel}>
      <Sidebar.Body className="p-4">
        {taskId && (
          <TaskReadCompleteView
            taskId={taskId}
            onDeleteTaskSuccess={() => {
              if (onClose) {
                // oxlint-disable-next-line typescript/no-meaningless-void-operator -- FIXME: pre-existing error: void operator shouldn't be used on void; it should convey that a return value is being ignored
                void onClose();
              }
              if (onDeleteTaskSuccess) {
                // oxlint-disable-next-line typescript/no-meaningless-void-operator -- FIXME: pre-existing error: void operator shouldn't be used on void; it should convey that a return value is being ignored
                void onDeleteTaskSuccess();
              }
            }}
            onUpdateTaskSuccess={onUpdateTaskSuccess}
            hideDealLink={hideDealLink}
          />
        )}
      </Sidebar.Body>
    </Sidebar>
  );
};
export default TaskReadCompleteDrawer;
